import request from "@/utils/request";

let FullreduceApi = {
    /*列表*/
    getList(data, errorback) {
        return request._post("/merch/setting.fullreduce/index", data, errorback);
    },
    /*添加*/
    add(data, errorback) {
        return request._post("/merch/setting.fullreduce/add", data, errorback);
    },
    /*修改*/
    edit(data, errorback) {
        return request._post("/merch/setting.fullreduce/edit", data, errorback);
    },
    /*删除*/
    del(data, errorback) {
        return request._post("/merch/setting.fullreduce/delete", data, errorback);
    },
    /*列表*/
    goods(data, errorback) {
        return request._post("/merch/operate.fullreduce/goods", data, errorback);
    },
    editGoods(data, errorback) {
        return request._post("/merch/operate.fullreduce/editGoods", data, errorback);
    }
};

export default FullreduceApi;



// WEBPACK FOOTER //
// ./src/api/fullreduce.js